import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
export var DropdownButton = function (_a) {
    var label = _a.label, selected = _a.selected, setSelected = _a.setSelected, options = _a.options, sx = _a.sx;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var anchorRef = React.useRef(null);
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
    };
    var handleClose = function (event) {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    var handleSelect = function (_, revisionId) {
        setSelected(revisionId);
        setOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: handleToggle, endIcon: _jsx(ArrowDropDownIcon, {}), size: "small", ref: anchorRef, id: "revisions-button", "aria-controls": open ? 'revisions-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, sx: sx, color: "inherit", children: label }), _jsx(Menu, { open: open, anchorEl: anchorRef.current, role: undefined, onClose: handleClose, id: "revisions-menu", MenuListProps: {
                    'aria-labelledby': 'revisions-button',
                }, children: options.map(function (option) { return (_jsx(MenuItem, { value: option.id, onClick: function (event) { return handleSelect(event, option.id); }, selected: selected === option.id, children: option.label }, option.id)); }) })] }));
};
